const baseUrl =
  process.env.VUE_APP_API_URL || 'http://api.dev.id.xbodyworld.com/api/';

export { baseUrl };
